export const ORDER_PPN_RECOMMENDATIONS_CACHE_KEY = "order-ppn-recommendations";
export const ORDER_STEDI_ELIGIBILITY_CHECK_CACHE_KEY = "order-stedi-eligibility-check";
export const ORDER_PATIENT_CASE_SYNC_CACHE_KEY = "order-patient-case-sync";
